<template>
  <el-dialog 
    v-if="isVisible"
    v-model="isVisible"
    width="970px"
    :title="testGroupNode.value.testName"
    append-to-body
    class="va-test-new-window-dialog order-test"    
    @close="close"
  >
    <template #header>
      <DialogTestNameWithCheckbox 
        :test-node="testGroupNode"
        :select-prop="selectProp"
        :is-not-allowed-select-prop="isNotAllowedSelectProp"
        class=" w-40"
        @click="handleClickTest(testGroupNode.value)"
      />
    </template>
    <DialogTestTreeNode 
      v-for="descendant in testGroupNode.descendants" 
      :key="descendant.id" 
      :test-node="descendant"
      :order-test-support-obj="orderTestSupportObj"
      :is-not-allowed-select-prop="isNotAllowedSelectProp"
      :filtered-test="filteredTest"
      @click="handleClickTest(testGroupNode.value)"
    />
  </el-dialog>
</template>

<script>
import DialogTestNameWithCheckbox from "./DialogTestNameWithCheckbox.vue"
import DialogTestTreeNode from "./DialogTestTreeNode.vue";
import { addSelectedTest, removeSelectedTest } from "@/utils/va-order-test/testAndPanelSelection/testSelection.js";
export default {
  components: {
    DialogTestNameWithCheckbox,
    DialogTestTreeNode
  },
  props: {
    isOpenNewWindow: {
      type: Boolean,
      default: false,
    },
    testGroupNode: {
      type: Object,
      default: () => {}
    },
    filteredTest: {
      type: Object,
      default: () => {},
    },
    selectProp: {
      type: String,
      default: "isSelect"
    },
    isNotAllowedSelectProp: {
      type: String,
      default: "isNotAllowedSelect"
    },    
    orderTestSupportObj: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      isVisible: this.isOpenNewWindow,
    };
  },

  watch: {
    isOpenNewWindow(newVal) {
      this.isVisible = newVal;
    }
  },

  methods: {
    close() {
      this.$emit("close");
    },

    // select or de-select test
    handleClickTest(test) {
      test[this.selectProp] 
        ? removeSelectedTest(test.id, this.selectProp, this.orderTestSupportObj)
        : addSelectedTest(test.id, this.selectProp, this.orderTestSupportObj);
    },
  }
}
</script>